import {StoreExt} from '@utils/reactExt'
import {observable, action, runInAction} from 'mobx'
import {userStore} from '@src/store'
class ExchangeStore extends StoreExt {
    @observable couponProduct: any = {}
    @observable isTicket: boolean = false
    @observable getTicketDone: boolean = false
    @action
    checkTicket = async (ticketCode, simId) => {
        try {
            const res = await this.api.checkTicket({ticketCode, simId})
            this.getTicketPackage({ticketCode: ticketCode, sign: res.sign})
        } catch (e) {}
    }

    @action
    setIsTicket = (value) => {
        this.isTicket = value;
    }

    // 获取兑换套餐详情
    @action
    getTicketPackage = async (param) => {
        let res = await this.api.getPackageByTicket(param)
        res.ticketValidType = res.validType
        res.ticketValidDays = res.validDays
        res = {...res, ...res.planInfoDto, ...{ticketCode: this.formatTicketCode(param.ticketCode), sign: param.sign}}
        if (res.planInfoDto && res.planInfoDto.discountId) {
            runInAction(() => {
                this.setIsTicket(true)
            })
        } else {
            this.goToPath(`/app/mine/exchange/detail/${param.ticketCode}/${param.sign}/${userStore.currentDeviceInfo.simId}`)
        }
        if (!!res.productInfo) {
            res.infoLists = res.productInfo.split('\n')
        } else {
            res.infoLists = []
        }
        runInAction(() => {
            this.couponProduct = res
        })
    }
    // 格式化兑换码
    formatTicketCode = (ticketCode) => {
        let goalStr = ''
        goalStr = ticketCode.slice(0, 4) + '-'
        goalStr = `${goalStr}${ticketCode.slice(4, 8)}-`
        goalStr = `${goalStr}${ticketCode.slice(8, 12)}-`
        goalStr = `${goalStr}${ticketCode.slice(12, 16)}`
        return goalStr
    }
    // 兑换套餐
    @action
    doSubmit = async (iccid, isTicket?) => {
        const param = {
            iccid: iccid,
            ticketCode: this.couponProduct.ticketCode.split('-').join(''),
            sign: this.couponProduct.sign
        }
        try {
            await this.api.useTicket(param)
            this.$toast.info('兑换成功')
            if (isTicket) {
                runInAction(() => {
                    this.getTicketDone = true
                })
            } else {
                this.goToPath(`/app/mine/ordering/list`)
            }
        } catch (err) {
            console.log(err)
        }
    }
}

const exchangeStore = new ExchangeStore()
export {
    exchangeStore,
    ExchangeStore
}
